module.exports = __webpack_public_path__ + "img/4.fc2e7405.png";